import { render } from "./sortNew.vue?vue&type=template&id=398534e6&scoped=true"
import script from "./sortNew.vue?vue&type=script&lang=js"
export * from "./sortNew.vue?vue&type=script&lang=js"

import "./sortNew.vue?vue&type=style&index=0&id=398534e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398534e6"]])

export default __exports__